export class Activity {
	constructor(
		public requirementid?: number,
		public subject?: string,
		public content?: string,
		public activity_date?: string,
		public activity_time?: string,
		//public email?: string,
	) { }
}